"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _colors = require("../colors");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj["default"] = obj;
    return newObj;
  }
}
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var standardDimensions = {
  large: '72px',
  medium: '38px',
  small: '16px'
};
var pageCenter = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};
var Spinner = /*#__PURE__*/
function (_PureComponent) {
  _inherits(Spinner, _PureComponent);
  function Spinner() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, Spinner);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Spinner)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_this), "getCurrentOffset", function () {
      var duration = _this.props.duration;
      return _this.el.getCurrentTime() % duration / duration;
    });
    _defineProperty(_assertThisInitialized(_this), "renderSpinner", function () {
      var offset = _this.props.offset;
      var _this$props = _this.props,
        duration = _this$props.duration,
        size = _this$props.size;
      offset %= 1;
      var begin = (1 - offset) * duration - duration;
      return _react["default"].createElement("div", {
        className: "spinner ".concat(_this.props.className),
        style: _this.props.fullPage ? pageCenter : {}
      }, _react["default"].createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: standardDimensions[size] || standardDimensions.large,
        height: standardDimensions[size] || standardDimensions.large,
        viewBox: "0 0 100 100",
        preserveAspectRatio: "xMidYMid",
        className: "uil-ring-alt",
        ref: function ref(el) {
          return _this.el = el;
        } // eslint-disable-line no-return-assign
      }, _react["default"].createElement("rect", {
        x: "0",
        y: "0",
        width: "100",
        height: "100",
        fill: "none",
        className: "bk"
      }), _react["default"].createElement("circle", {
        cx: "50",
        cy: "50",
        r: "40",
        stroke: _colors.alloy,
        fill: "none",
        strokeWidth: "10",
        strokeLinecap: "butt"
      }), _react["default"].createElement("circle", {
        cx: "50",
        cy: "50",
        r: "40",
        stroke: _colors.info.darkest,
        fill: "none",
        strokeWidth: "10",
        strokeLinecap: "butt"
      }, _react["default"].createElement("animate", {
        attributeName: "stroke-dashoffset",
        dur: duration,
        repeatCount: "indefinite",
        from: "0",
        to: "-502",
        begin: begin
      }), _react["default"].createElement("animate", {
        attributeName: "stroke-dasharray",
        dur: duration,
        repeatCount: "indefinite",
        values: "75.3 175.7;1 250;75.3 175.7",
        begin: begin
      }))));
    });
    return _this;
  }
  _createClass(Spinner, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.handleOffset && this.props.handleOffset(this.getCurrentOffset());
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.fullPage ? _reactDom["default"].createPortal(this.renderSpinner(), document.body) : this.renderSpinner();
    }
  }]);
  return Spinner;
}(_react.PureComponent);
exports["default"] = Spinner;
Spinner.propTypes = {
  className: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(['large', 'medium', 'small']),
  duration: _propTypes["default"].number,
  offset: _propTypes["default"].number,
  handleOffset: _propTypes["default"].func,
  fullPage: _propTypes["default"].bool
};
Spinner.defaultProps = {
  size: 'large',
  className: '',
  duration: 2,
  offset: 0,
  fullPage: false
};